import React, { useCallback, useEffect, useState, useRef, useMemo } from 'react';

import {
  makeStyles,
  Grid,
  Container,
  Paper,
  Typography,
} from '@material-ui/core';

import { useAppConfig } from "../../context/AppConfigContext";
import AppConfig from "../../model/AppConfig";
import useGetRecalls from '../../hooks/useGetRecalls';
// import useGetSharedRecall from '../../hooks/useGetSharedRecall';
import DialogRecall from '../Recall/DialogRecall';
import HeroSearch from '../search/HeroSearch';

import CardSkeleton from '../../utils/LoadingSkeletons';
import CardRecall from '../Recall/CardRecall';

import Bottombar from '../layout/Bottombar';
import Lightbox from 'react-image-lightbox';

import {preprocessString} from '../../utils/common';
import {
  chatbot
} from '../../routes/routes.json';

import chatbotImg from '../../assets/static/chatbot.png';

const useStyle = makeStyles((theme) => ({
  categoriesList: {
    width: '100%',
    minHeight: '100vh',
    paddingTop: 60,
  },
  searchContainer: {
    paddingTop: 10,
    paddingBottom: 10,
    // marginBottom: 15,
    // [theme.breakpoints.down('md')]: {
    //   marginBottom: 30,
    // },
  },
  headerTitle: {
    color: "black",
    fontSize: "20px",
  },
  loader: {
    display: 'none',
  },
  container: {
    paddingRight: "10px",
    paddingLeft: "10px",
    [theme.breakpoints.only('xs')]: {
        paddingRight: "5px",
        paddingLeft: "8px",
    },
  },
  fab: {
    position: "fixed",
    bottom: "60px",
    right: "10px"
  },
  chatbotImg: {
    width: "60px",
    height: "60px"
    },
}));

function isValidSelectedRecall(selectedRecall) {
  return !!selectedRecall && !!selectedRecall.compositeId;
}

const updateUrl = function(selectedRecall) {
  //console.log("Updating url...", selectedRecall);

  const windowUrl = new URL(window.location.href);

  if (isValidSelectedRecall(selectedRecall)) {
    const path = '/' + selectedRecall.compositeId;
    
    windowUrl.searchParams.delete('appLink');

    console.log("Update path...", path);
    const newUrl = windowUrl.origin + path + windowUrl.search;
    window.history.replaceState({}, "", newUrl);
  } else {
    //console.log("Update path...");
    const newUrl = windowUrl.origin + windowUrl.search;
    window.history.replaceState({}, "", newUrl);
  }
};

const headers = ["Recent Alerts", 
                  "Severe Alerts",
                  "Microbe Alerts",
                  "Pet Food Alerts",
                  "Other Alerts"];

// Returns sorted and filtered array of recalls
const getAllRecallsArray = (allRecalls, tabBarIndex) => {
  let tempRecalls = Object.values(allRecalls)
    .sort((a,b) => b.id - a.id)
    .sort((a,b) => b.getDate() - a.getDate());
  
  switch (tabBarIndex) {
    case 0:
      //All
      //tempRecalls = tempRecalls;
      break;
    case 1:
      //Severe
      tempRecalls = tempRecalls.filter(recall => recall.hasBreakingNews());
      break;
    case 2:
      //Microbe
      tempRecalls = tempRecalls.filter(recall => recall.isMicrobeRecall());
      break;
    case 3:
      //Pet
      tempRecalls = tempRecalls.filter(recall => recall.isPetFoodRecall());
      break;
    case 4:
      //Other
      tempRecalls = tempRecalls.filter(recall => recall.isOtherRecall());
      break;
    default:
      //tempRecalls = tempRecalls;
  }

  return tempRecalls;
};

let pageSize = 10;

const MainList = (props) => {
  const classes = useStyle();
  const { appConfigDict } = useAppConfig();

  const { displayRecall } = props;
  // console.log( displayRecall );

  const [loading, setLoading] = useState(true);

  // Simple pagination.
  // Load everything once but display one page at a time
  const loader = useRef(null);
  const [page, setPage] = useState(1);
  
  const [tabBarIndex, setTabBarIndex] = useState(0);
  const [allRecalls, setAllRecalls] = useState({});
  const [filteredRecalls, setFilteredRecalls] = useState([]);
  
  const headerText = useMemo(() => 
    `${headers[tabBarIndex]} in ${AppConfig.getPrettyCountryDescription(appConfigDict.country)}`, 
    //`${AppConfig.getFlag(appConfigDict.country)} ${headers[tabBarIndex]} in ${AppConfig.getPrettyCountryDescription(appConfigDict.country)}`, 
    [tabBarIndex, appConfigDict.country]
  );
  const [header, setHeader] = useState(headerText);

  const [selectedRecall, setSelectedRecall] = useState(null);
  
  const [searchText, setSearchText] = useState(null);
  const [closeSearch, setCloseSearch] = useState(false);

  const [openDialog, setOpenDialog] = useState(false);
  
  const [photoIndex, setPhotoIndex] = useState(0)
  const [lightBoxOpen, setLightBoxOpen] = useState(false);
  const [images, setImages] = useState([]);

  useGetRecalls(appConfigDict, setLoading, setAllRecalls);

  useEffect(() => {
    setSelectedRecall(displayRecall);
  }, [displayRecall]);

  useEffect(() => {
    //console.log('Filtered recalls for tab: ', tabBarIndex);
    let tempRecalls = getAllRecallsArray(allRecalls, tabBarIndex);

    //console.log(tempRecalls);
    setFilteredRecalls(tempRecalls);
    setLoading(false);

    // setHeader(headerText);

    //Set page to 1
    setPage(1);
  }, [allRecalls, tabBarIndex]);


  useEffect(() => {
    setHeader(headerText);
  }, [headerText]); // ✅ Ensures updates when `tabBarIndex` or `appConfigDict.country` changes

  useEffect(() => {
    if( closeSearch ) {
      setSearchText(null);

      let tempRecalls = getAllRecallsArray(allRecalls, tabBarIndex);

      setFilteredRecalls(tempRecalls);
      setLoading(false);
      setCloseSearch(false);
      
      //setHeader(headers[tabBarIndex] + " in the US");

      //Set page to 1
      setPage(1);
    }
  }, [closeSearch, allRecalls, tabBarIndex])

  useEffect(() => {
    if (searchText && searchText !== "") {
      console.log("Search text is set to", searchText);
      let text = preprocessString(searchText)

      let scope = 0 //tabBarIndex

      let tempRecalls = getAllRecallsArray(allRecalls, scope);
      tempRecalls = tempRecalls.filter(recall => recall.getSearchFriendlyDescription().toLowerCase().includes(text.toLowerCase()));
      setFilteredRecalls(tempRecalls);
      setLoading(false);

      setHeader(headers[scope] + ` related to "${searchText}"`);

      //Set page to 1
      setPage(1);
    }
  }, [searchText, allRecalls, tabBarIndex]);

  useEffect(() => {
    if(loading) {
      //console.log("Loading flag is set to true...");
      setTimeout( () => {
        setLoading(false);
      }, 5000);
    } else {
      //console.log("Loading flag is set to false...");
    }
  }, [loading]);

  useEffect(() => {
    if( isValidSelectedRecall(selectedRecall) ) {
      console.log(`Selected recall is ${selectedRecall.compositeId}`);
      //Change url to /fda/xxxx
      updateUrl(selectedRecall);
      setOpenDialog(true);
    } else {
      //Reset the url
      updateUrl(selectedRecall);
      setOpenDialog(false);
    }
  }, [selectedRecall]);

  useEffect(() => {
    setLoading(true);
    return () => {
      setAllRecalls({});
    };
  }, []);

  const fetchData = useCallback( () => {
    if (page * pageSize > filteredRecalls.length) {
      return
    }
    setPage((prevPage) => prevPage + 1);
    //console.log("Setting page to", page)
  }, [filteredRecalls, page]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        fetchData();
      }
    });

    const refCopy = loader.current;
    if (refCopy) {
      observer.observe(refCopy);
    }

    return () => {
      if (refCopy) {
        observer.unobserve(refCopy);
      }
    };
  }, [fetchData]);

  useEffect(() => {
    console.log("Page..", page);
  }, [page]);

  useEffect(() => {
    //console.log("Setting openDialog", openDialog);

    if (openDialog) {
      if (window.NativeAndroid && window.NativeAndroid.setDialogueState) {
        window.NativeAndroid.setDialogueState(true);
      }
    } else {
      if (window.NativeAndroid && window.NativeAndroid.setDialogueState) {
        window.NativeAndroid.setDialogueState(false);
      }
    }
  }, [openDialog]);

  const handleOpenDialog = function(event) {
    const compositeId = event.currentTarget.id; //id

    setSelectedRecall({"compositeId": compositeId});
    setLightBoxOpen(false);
  };

  const handleCloseDialog = useCallback(() => {
    // Remove fda/xxxx or usda/yyyy from the URL
    //updateUrl(selectedRecall);

    if (lightBoxOpen) {
      setLightBoxOpen(false);
    } else {
      setSelectedRecall(null);
    }
  }, [lightBoxOpen]);

  const handleImgClicked = (event) => {
    const index = event.currentTarget.getAttribute('data-index'); //index

    console.log('Image clicked ', index);

    setPhotoIndex(parseInt(index));
    setLightBoxOpen(true);
    const selected = getSelectedRecall();
    if (selected) {
      setImages(selected.getAllImages());
    }
  };

  // Handle Android hardware backbutton
  useEffect(() => {
    console.log("Registering event listener for Android hardware back button...")
    window.addEventListener("onAndroidGoBack", handleCloseDialog);
    return () => {
      console.log("Unregistering event listener for Android hardware back button...")
      window.removeEventListener("onAndroidGoBack", handleCloseDialog);
    };
  }, [handleCloseDialog])

  const getSelectedRecall = () => {
    if (!allRecalls || !selectedRecall?.compositeId) return null;

    let recall = allRecalls[selectedRecall.compositeId] || 
               allRecalls[selectedRecall.compositeId?.replace('fda', 'other')];

    return recall ?? null; // Ensure it returns `null` instead of `undefined`
  }

  return (
    <Paper>
      <Grid container className={classes.categoriesList}>
        <Container maxWidth="md" className={classes.container}>
          <Grid container>
            <Grid item xs={12} className={classes.searchContainer}>
              <HeroSearch setSearchText={setSearchText} setCloseSearch={setCloseSearch} setLoading={setLoading}/>
            </Grid>
            <Grid item xs={12}>
              <Typography
                variant="h2"
                color="initial"
                className={classes.headerTitle}
              >
                {header}
              </Typography>
            </Grid>
            <Grid container spacing={0} columns={1}>
              {loading ? (
                <CardSkeleton />
              ) : (
                filteredRecalls.slice(0, page*pageSize).map((recall, index) => (
                  //console.log(0, page*pageSize)
                  <Grid xs={12} item key={index} id={recall.compositeId} onClick={handleOpenDialog}>
                    <CardRecall
                      // key={index}
                      // id={index}
                      // onClick={handleOpenDialog}
                      recall={recall}
                    />
                  </Grid>
                ))
              )}
              <div ref={loader} />
            </Grid>
            <Bottombar tabBarIndex={tabBarIndex} setTabBarIndex={setTabBarIndex} setLoading={setLoading}/>
          </Grid>
        </Container>
      </Grid>
      { isValidSelectedRecall(selectedRecall) && !!getSelectedRecall() ? (
        <DialogRecall
            open={openDialog}
            handleClose={handleCloseDialog}
            handleImgClicked={handleImgClicked}
            recall={getSelectedRecall()}
        />) : (null)
      }
      { lightBoxOpen && isValidSelectedRecall(selectedRecall) ? (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setLightBoxOpen(false)}
            onMovePrevRequest={() =>
              setPhotoIndex( (photoIndex + images.length - 1) % images.length )
            }
            onMoveNextRequest={() =>
              setPhotoIndex( (photoIndex + 1) % images.length )
            }
            imageTitle={`${photoIndex + 1} of ${images.length}`}
          />
        ) : (null)}
        <div className={classes.fab}>
          <a
            href={chatbot}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={chatbotImg} alt="chatbot" className={classes.chatbotImg} />
          </a>
        </div>
    </Paper>
  );
};

export default MainList;
